module.exports = __webpack_public_path__ + "static/img/qualifications_row_15.7c3e718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_15.png
// module id = 1OiS
// module chunks = 1